import useLabels from '../../hooks/useLabels';
import { createContext, ReactNode, useContext, useEffect, useState } from 'react';

type RouteStateContextType = {
    isDirty: boolean;
    setIsDirty: (dirty: boolean) => void;
};

const RouteStateContext = createContext<RouteStateContextType | undefined>(undefined);

export const useRouteStateContext = () => {
    const context = useContext(RouteStateContext);
    if (!context) throw new Error("useRouteStateContext must be used within FormStateProvider");
    return context;
};

export const RouteStateProvider = ({ children }: { children: ReactNode; }) => {
    const labels = useLabels();
    const [isDirty, setIsDirty] = useState(false);

    useEffect(() => {
        const signal = new AbortController();
        window.addEventListener("beforeunload", (e: BeforeUnloadEvent) => {
            if (!isDirty) return;
            const message = labels.youHaveUnsavedChangesPrompt;
            e.returnValue = message; // Standard for most browsers
            return message; // For older browsers
        }, signal);

        return () => { signal.abort(); };
    }, [isDirty, labels.youHaveUnsavedChangesPrompt]);

    return (
        <RouteStateContext.Provider value={{ isDirty, setIsDirty }}>
            {children}
        </RouteStateContext.Provider>
    );
};
